// Purpose: Simple helper to fetch processed garments JSON
// Author: o3 AI assistant
// Last Updated: 2025-08-02

/**
 * Fetch garments.json that was generated by syncGarments.js
 * Returns an array of garment objects.
 */
export const fetchGarments = async () => {
  try {
    const res = await fetch('/data/garments.json', { cache: 'no-store' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } catch (err) {
    console.error('Failed to fetch garments.json', err);
    return [];
  }
};
